import _ from 'lodash';
import $ from 'cheerio';
import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import Timestamp from '../Timestamp';
import Image from 'components/Image';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import convert from 'xml-js';

// TODO:
// 1. Move this to components/social/BlogSummary.js
// 2. Use pure CSS multiline ellipsis: https://codepen.io/martinwolf/pen/qlFdp
// 3. Consider breaking this apart into multiple modules per feed type or accept
//    feed type as a prop

const blogImageUriRegex = /<img.*src=["'](\S+)["']\ .*\/>/;

/**
 * Class representing a sample of the most recent weather blog for the station.
 */
class WeatherBlog extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    timestampOptions: PropTypes.shape({
      showElapsedTime: PropTypes.bool,
      displayShortDateTime: PropTypes.bool
    }),
    titleType: PropTypes.string
  };

  static defaultProps = {
    title: "Weather Blog",
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  _getImageUri(blog, blogHtml) {
    // TODO: This can be improved by doing the following:
    // 1. improve regex performance
    // 2. Use blogspot's thumbnail hack
    let uri = '';

    // Try get assuming frankly feed
    if (_.startsWith(_.get(blog, 'enclosure[@type]'), 'image/')) {
      uri = _.get(blog, 'enclosure[@url]', '');
    }

    if (!uri) {
      // Try get from html
      const matches = blogHtml.match(blogImageUriRegex) || [];
      uri = matches[1] || '';
    }

    if (!uri) {
      // Try get assuming blogspot
      uri = _.get(blog, 'media:thumbnail[@url]');
    }

    return uri;
  }

  _getTextContent(html) {
    // NOTE: Need to wrap with p because $ can't handle more than one tag at root
    return $('<p>' + html + '</p>').text();
  }

  _cleanXmlObj(arr) {
    return arr.map(obj => ({
      ...obj, 
      title: obj.title._cdata, 
      description: obj.description._text,
      pubDate: obj.pubDate._text,
      enclosure: obj.enclosure ? {
        ...obj.enclosure,
        '@type': obj.enclosure._attributes.type,
        '@url': obj.enclosure._attributes.url,
      } : {}
    }));
  }

  render() {
    if (!this.props.FRN_rawResponses || this.props.FRN_rawResponses.length === 0) {
      return null;
    }

    let dataStr = this.props.FRN_rawResponses[0].data;
    try {
      if (dataStr && typeof dataStr === 'string') {
        this.props.FRN_rawResponses[0].data = convert.xml2js(dataStr, {compact: true});
        this.props.FRN_rawResponses[0].data.rss.channel.item = this._cleanXmlObj(this.props.FRN_rawResponses[0].data.rss.channel.item);
      }
    } catch (error) {
      console.log(error);
    }

    const {
      title,
      titleType,
      timestampOptions: {
        showElapsedTime,
        displayShortDateTime
      } = {},
      FRN_rawResponses: [
        {
          data: {
            rss: {
              channel: {
                item: [
                  blogItem = null
                  ] = []
                } = {}
              } = {}
          } = {}
        } = {}
      ] = []
    } = this.props;
    const blog = _.isArray(blogItem) ? blogItem[0] : blogItem;

    if (!blog) {
      return null;
    }

    const {
      pubDate: publishDate = '',
      title: blogTitle = '',
      link = '',
      'content:encoded': contentEncoded = '',
      description = ''
    } = blog;

    // TODO: Find a better way to fix this
    // Typecast uses 'content:encoded'
    const blogHtml = contentEncoded || _.unescape(description);
    const blogImageUri = this._getImageUri(blog, blogHtml);

    let textContent = this._getTextContent(blogHtml);
    if (_.size(textContent) > 200) {
      textContent = textContent.substr(0, 200) + '...';
    }

    /* Breakpoints: XS: 0-767, S: 768-991, M: 992-1199, L: 1200-1469, XL: 1470-  */
    const imageBreakpoints = [
      { "maxWidth": 640, "widthVW": 100 },
      { "maxWidth": 768, "widthVW": 100 },
      { "maxWidth": 992, "widthPX": 992 },
      { "maxWidth": 1200, "widthPX": 1200 },
      {                   "widthPX": 1410 },
    ];

    return (
      <div className="WeatherBlog">
        <ComponentTitle titleType={titleType} title={title} />
        <div className="WeatherBlog-entry">
          <div className="WeatherBlog-imageContainer">
            {/* The following image tag is here for accessibility purposes */}
            {blogImageUri ? <Image imageBreakpoints={imageBreakpoints} src={blogImageUri} alt={blogTitle} imageClassNames={"img-responsive"} /> : null}
          </div>
          <div className="WeatherBlog-info">
            <h4 className="WeatherBlog-title">{blogTitle}</h4>
            <p className="WeatherBlog-abstract" >
              <span>{textContent}</span>
            </p>
            <Timestamp publishDate={publishDate} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime}/>
          </div>
          <a href={link} className="WeatherBlog-link" target="_top"/>
        </div>
      </div>
    );
  }
}

export default WeatherBlog;



// WEBPACK FOOTER //
// ./app/components/weather/WeatherBlog.js